import React from "react";
import PropTypes from "prop-types";
import "../../styles/StepIndicator.scss";

const StepIndicator = (props) => {
    const { totalStepper, activeStepper, children } = props;
    const stepper = [...Array(totalStepper).keys()];

    const handleActiveStepStyle = (item) => {
        const defaultClass = "mr-10 tab";
        const updatedClass = (activeStepper === item) ? defaultClass + " active-tab" : defaultClass + " in-active-tab";
        return updatedClass;
    }

    return (
        <React.Fragment>
            <div>
                <div className="steps">
                    {stepper.map((x) => {
                        return (
                            <div key={x} data-testid={`stepper-${x}`} className={handleActiveStepStyle(x)}></div>
                        )
                    })}
                </div>
                {children}
            </div>
        </React.Fragment>
    )
};

StepIndicator.propTypes = {
    totalStepper: PropTypes.number,
    activeStepper: PropTypes.number,
    children: PropTypes.element
}

export default StepIndicator;